/** @format */

const HomeCarouselTranslations = {
  en: {
    'Carousel.caption.button': 'Check out our services',
    'Carousel.caption.title1': '',
    'Carousel.caption.text1': '',
    'Carousel.caption.title2': '',
    'Carousel.caption.text2': '',
    'Carousel.caption.title3': '',
    'Carousel.caption.text3': '',
    'Carousel.caption.title4': '',
    'Carousel.caption.text4': '',
    'Carousel.caption.title5': '',
    'Carousel.caption.text5': '',
  },
  it: {
    'Carousel.caption.button': 'Scopri i servizi',
    'Carousel.caption.title1': '',
    'Carousel.caption.text1': '',
    'Carousel.caption.title2': '',
    'Carousel.caption.text2': '',
    'Carousel.caption.title3': '',
    'Carousel.caption.text3': '',
    'Carousel.caption.title4': '',
    'Carousel.caption.text4': '',
    'Carousel.caption.title5': '',
    'Carousel.caption.text5': '',
  },
};

export default HomeCarouselTranslations;
